import { IconArrowLeft, IconUser } from "@tabler/icons-react";
import { useNavigate, useRouterState } from "@tanstack/react-router";
import type { MenuProps } from "antd";
import { Menu } from "antd";

const items: MenuProps["items"] = [
	{
		key: "/account",
		icon: <IconUser height="1.3em" />,
		label: "Account",
	},
	{ type: "divider" as const },
	{
		key: "/",
		icon: <IconArrowLeft height="1.3em" />,
		label: "Back",
	},
];

export function AccountNav({ onNavigate }: { onNavigate?: () => void }) {
	const navigate = useNavigate();
	const pathname = useRouterState({ select: (s) => s.location.pathname });

	return (
		<Menu
			mode="inline"
			inlineIndent={10}
			selectedKeys={[pathname]}
			onClick={({ key }) => {
				navigate({ to: key });
				onNavigate?.();
			}}
			style={{ height: "100%" }}
			items={items}
		/>
	);
}
